<template>
  <div>
    <div
      v-if="
        featureFlags.cx14_1426_loyalty_point_integration &&
          marketAttributes &&
          (marketAttributes.earn || marketAttributes.redeem)
      "
      class="ns-loyalty-information"
      :class="{ 'ns-loyalty-information__product-detail': productDetail }"
    >
      <div
        class="ns-loyalty-information__message"
        itemprop="loyaltyInformation"
      >
        <div class="loyalty_options">
          <div class="rewards_available">
            <div class="rewards_icon">
              <img :src="loyaltyStatusAndLinks.siteUrl + coinUrl" />
            </div>
            <div v-if="!isLoggedIn || !isOptedIn" class="rewards_message">
              <a
                :href="
                  loyaltyStatusAndLinks.siteUrl +
                    loyaltyStatusAndLinks.landingPage
                "
              >
                {{ loyaltyStatusAndLinks.notOptedIn }}
              </a>
            </div>
            <div v-if="isLoggedIn && isOptedIn" class="rewards_message">
              <a
                :href="
                  loyaltyStatusAndLinks.siteUrl +
                    loyaltyStatusAndLinks.dashboardPage
                "
              >
                {{ dashboardLinkMessage }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else-if="marketAttributes && marketAttributes.earn"
      class="ns-loyalty-information"
      :class="{ 'ns-loyalty-information__product-detail': productDetail }"
    >
      <div
        class="ns-loyalty-information__message"
        itemprop="loyaltyInformation"
      >
        <div class="loyalty_options">
          <div class="rewards_available">
            <div class="rewards_icon">
              <img
                :src="
                  loyaltyStatusAndLinks.siteUrl +
                    '/content/dam/apps/loyalty/global/loyalty_coin_blue.svg'
                "
              />
            </div>
            <div v-if="!isLoggedIn || !isOptedIn" class="rewards_message">
              <a
                :href="
                  loyaltyStatusAndLinks.siteUrl +
                    loyaltyStatusAndLinks.landingPage
                "
              >
                {{ loyaltyStatusAndLinks.landingPageLinkMessage }}
              </a>
            </div>
            <div v-if="isLoggedIn && isOptedIn" class="rewards_message">
              <a
                :href="
                  loyaltyStatusAndLinks.siteUrl +
                    loyaltyStatusAndLinks.dashboardPage
                "
              >
                {{ loyaltyStatusAndLinks.dashboardLinkMessage }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NsLoyaltyInformation",
  props: {
    marketAttributes: {
      type: Object,
      default() {
        return {};
      }
    },
    loyaltyStatusAndLinks: {
      type: Object,
      default() {
        return {};
      }
    },
    sku: {
      type: String,
      default: ""
    },
    isLoggedIn: Boolean,
    isOptedIn: Boolean,
    translations: {
      type: Object,
      default() {
        return {};
      }
    },
    userLoyalty: {
      type: Object,
      default() {
        return {};
      }
    },
    featureFlags: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    coinUrl() {
      if (
        this.isLoggedIn &&
        this.isOptedIn &&
        (!this.marketAttributes.earn || !this.marketAttributes.redeem)
      ) {
        return "/content/dam/apps/loyalty/global/loyalty_coin_green.svg";
      } else {
        return "/content/dam/apps/loyalty/global/loyalty_coin_blue.svg";
      }
    },
    dashboardLinkMessage() {
      if (this.marketAttributes.earn && this.marketAttributes.redeem) {
        return this.loyaltyStatusAndLinks.productOptedInEarnAndRedeem;
      } else if (this.marketAttributes.earn) {
        return this.loyaltyStatusAndLinks.productOptedInEarnNotRedeem;
      } else {
        return this.loyaltyStatusAndLinks.productOptedInRedeemNotEarn;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/colors";
@use "~@nuskin/ns-core-styles/src/scss/typography";
@use "~@nuskin/ns-core-styles/src/scss/typographyVariables";

.ns-loyalty-information {
  display: grid;
  grid-gap: 20px;
  grid-auto-flow: column;
  justify-content: center;
}

.ns-loyalty-information__message {
  position: relative;

  .loyalty_options {
    float: left;
    clear: both;
    width: 100%;
    font-size: 14px;

    a {
      text-decoration: none;
      position: relative;
      color: #000000;
    }
    a:after {
      content: "";

      width: 100%;
      position: absolute;
      left: 0;
      bottom: 0px;

      border-width: 0 0 1px;
      border-style: solid;
    }

    .rewards_available {
      .rewards_icon {
        display: inline-block;
        vertical-align: middle;
        margin-right: 5px;
        height: 30px;
      }
      .rewards_message {
        display: inline-block;
        color: #000000, 85%;
        vertical-align: middle;
        font-weight: map.get(
          typographyVariables.$typography,
          font-weight-semibold
        );
      }
    }
    .rewards_earn_available {
      .rewards_icon {
        display: inline-block;
        vertical-align: middle;
        margin-right: 5px;
        height: 30px;
      }
      .rewards_message {
        display: inline-block;
        color: #000000, 85%;
        vertical-align: middle;
        font-weight: map.get(
          typographyVariables.$typography,
          font-weight-semibold
        );
      }
    }
  }
}
</style>
